import { render, staticRenderFns } from "./look-coupon.vue?vue&type=template&id=1d980856&scoped=true"
import script from "./look-coupon.vue?vue&type=script&lang=ts"
export * from "./look-coupon.vue?vue&type=script&lang=ts"
import style0 from "./look-coupon.vue?vue&type=style&index=0&id=1d980856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d980856",
  null
  
)

export default component.exports